import React from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { FinanceWorkspace } from "@/components/finance/FinanceWorkspace";

export default function Billing() {
  return <div><PageHeader title="Billing & Payments" subtitle="Commitments, collections and protected client funds — connected to every matter." /><FinanceWorkspace /></div>;
}
